import { createContext } from 'react';

type ContextType = {
    open: boolean;
    handleClose: (e?: React.MouseEvent<HTMLLIElement | HTMLAnchorElement>) => void;
};
export const MoreMenuContext = createContext<ContextType>({ open: false, handleClose: () => null });
